import React, { FunctionComponent, useEffect, useState } from 'react';
import DashLayout from '../functionalComponents/DashboardLayout/DashboardLayout';
import DashRouters from '../../configs/routers/dashboard-routers.json';
import { Row, Col, Button, Form, Table, Spinner, Image, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faPencilAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import AddOrganizationModal from '../Modals/addOrganizationModal';
import EditOrganizationModal from '../Modals/editOrganizationModal';
import SessionService from '../../services/SessionsService';
import AddOrganizationSlots from '../Modals/addOrganizationSlots';
import Drawer from './Drawer';

import orgIcon from '../../assets/img/ui_icons/iam.png'

import Logo from '../../assets/img/ilustracion_noInfo2.png';
import editicon from '../../assets/img/ui_icons/cld_edit_table.svg';
import deleteIcon from '../../assets/img/ui_icons/cld_delete.svg';
import { BrowserView, MobileView } from 'react-device-detect';
import Disclaimer from '../mobileComponents/Disclaimer';
import { useHistory } from 'react-router-dom';
import Nodata from './components/Nodata';
import Cookies from 'universal-cookie';
import UpgradePlanModal from '../Modals/UpgradePlanModal';



//Note Cloud: Organization view

interface Region {
  id: number;
  region: string;
  server: string;
  code: string;
}

interface Developers {
  dev_id: number;
  email: string;

}

type IncomeProps = {};

const Organizations: FunctionComponent<IncomeProps> = ({ }) => {
  const [projects, setProjects] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [filtro, setFilter] = useState('');
  const [selected_org, setSelectedOrg] = useState(0);
  const [selected_org_name, setSelectedOrgName] = useState('');
  const [selected_org_description, setSelectedOrgDescription] = useState('');
  const [selected_org_region_id, setSelectedOrgRegionId] = useState(0);
  const [selected_org_region_name, setSelectedOrgRegionName] = useState('');
  const [selected_org_responsible_id, setSelectedOrgResponsibleId] = useState(0);
  const [selected_org_responsible_email, setSelectedOrgResponsibleName] = useState('');
  const [selected_org_devs, setSelectedOrgDevs] = useState<Developers[]>([]);

  const [currentSuscripcion, setCurrentSusbscription] = useState(0);

  const [currentOrganizations, setCurrentOrganizations] = useState(0);
    const [SusMax, setSusMax] = useState(0);
  const [maxOrganizations, setMaxOrganizations] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [isAddOrgDrawerOpen, setIsAddOrgDrawerOpen] = useState(false);
  const [addingOrg, setaddingOrg] = useState(false);
  const [developerNames, setDeveloperNames] = useState({});
  const [regions, setRegions] = useState<Region[]>([]);
  const [deployments, setDeployments] = useState<any[]>([]);
  const [showUpgrade, setShowUpgrade] = useState(false);

  const whenClosing = () => { setShowUpgrade(false) }

  const [recoveredProjects, setRecoverdProjects] = useState([]);

  const history = useHistory()

  const toggleEditDrawer = async (org_id) => {
    // if (isEditDrawerOpen == true) getProjects('');
    await fetchOrgDevs(org_id, true);


    setIsEditDrawerOpen(!isEditDrawerOpen);
    history.push('/organizations')
  };

  const editedDrawer = async (org_id) => {
    if (isEditDrawerOpen == true) getProjects('');
    await fetchOrgDevs(org_id, true);


    setIsEditDrawerOpen(!isEditDrawerOpen);
    history.push('/organizations')
  };
  
  const toggleAddOrgDrawer = async (org_id) => {
    await fetchOrgDevs(org_id, true);
    setIsAddOrgDrawerOpen(!isAddOrgDrawerOpen);
  };

  const changeFilter = (e) => {
    const newFilter = e.target.value;
    setFilter(newFilter);
    if (newFilter.length>0) filterProjects(newFilter); else filterProjects('')
  };

  const handleOrg = () => {
    setaddingOrg(!addingOrg);
    //document.getElementById('buscador')?.focus();
    getProjects('');
  };
  const closeOrg = () => {
    setaddingOrg(!addingOrg);
    //document.getElementById('buscador')?.focus();
    // getProjects('');
  };
  const handleModal = () => {
    getProjects('');
    setShowModal(!showModal);
    //document.getElementById('buscador')?.focus();
    setTimeout(() => {
      SessionService.dispatchOrganizationChangedEvent();
    }, 1000);
  };

  // Function to open the Edit Drawer with selected organization details
  const handleModal2 = (orgId: number, orgName: string, orgDescription: string, region_id: number, region_name: string, developerMail: string, developerID: number) => {
    setSelectedOrg(orgId);
    setSelectedOrgName(orgName);
    setSelectedOrgDescription(orgDescription);
    setSelectedOrgRegionId(region_id);
    setSelectedOrgRegionName(region_name);
    setSelectedOrgResponsibleId(developerID);
    setSelectedOrgResponsibleName(developerMail)
    //console.log(region_name)
    //console.log(region_id)
    //console.log(developerMail)
    //console.log(developerID)
    toggleEditDrawer(orgId);

    
  };


      const getConsumption = async (disableCache = false) => {
        const result = await ObexRequestHandler.get('/consumption', {}, !disableCache);
        const { success, data } = result;
        if (success) {
     
          setCurrentSusbscription(data.subscriptionInfo.subscription_id);
    
        }
      }

  const fetchOrgDevs = async (organization, owners = false) =>{

    const devs = (await ObexRequestHandler.get(`/organization_devs?organization=${organization}`, {}, true)).data || [];


      if (owners){

        const filteredData = devs.filter(item => 
          item.isOwner === true || 
          ((item.roles && item.roles.some(role => role && role.obex_role_id === 35)) /*||
          (item.roles && item.roles.some(role => role && role.obex_role_id === 2))*/) &&
          item.validated && item.confirmed

        );

setSelectedOrgDevs(filteredData); 
      } else  setSelectedOrgDevs(devs);
  }

const fetchDeployments = async () =>{
  try {
    const cookies = new Cookies();
    const userInfo = cookies.get('101Obex');
    const response = await ObexRequestHandler.get(`/get_deployments?avap_id=${userInfo.avap_id}`);
    if (response.data) {
      const deployments_ = response.data;
      setDeployments(deployments_);
  } else {
      console.error('Error in the request:', response.data.error);
  }
  } catch (error) {
    console.error('Error at fetching deployments', error);

}
history.push('/organizations')

}

  const fetchRegions = async () => {
    try {
     const response = await ObexRequestHandler.get('/servers_regions');

        if (response.data) {
            const regions_ = response.data;
            setRegions(regions_);
        } else {
            console.error('Error in the request:', response.data.error);
        }
    } catch (error) {
        console.error('Error at fetching regions', error);

    }
    history.push('/organizations')
};

const filterProjects = async (filtro) => {

  const filter_projects = recoveredProjects.filter(element =>
    element.name.toLowerCase().includes(filtro.toLowerCase())
  );
  setProjects(filtro === '' ? recoveredProjects : filter_projects);

}


  const getProjects = async (filtro: string) => {
    try {
      setLoading(true);
      setProjects([]);
      const projects = (await ObexRequestHandler.get('/organizations', {}, true)).data || [];
      //console.log('Fetched Projects:', projects);
      setCurrentOrganizations(projects['result'].length);
      setMaxOrganizations(projects['max']);
      setSusMax(projects['sus_max'])

  
      const filter_projects = projects['result'].filter(element =>
        element.name.toLowerCase().includes(filtro.toLowerCase())
      );
      setProjects(filtro === '' ? projects['result'] : filter_projects);

      setRecoverdProjects(projects['result']);
  
      // Obtener detalles de los desarrolladores para cada proyecto
      for (const project of projects.result) {
        if (project.developers > 0) {
          try {
            const developerDetails = await ObexRequestHandler.get(`/organizations/${project.id}/developers`);//revisar si hay un endpoint
            console.log(`Developer for project ${project.id}:`, developerDetails.data || 'No developer data');
          } catch (error) {
            console.error(`Error fetching developer for project ${project.id}:`, error);
          }
        }
      }
    } catch (error) {
      console.error('ERROR FETCHING PROJECTS ', error);
    } finally {
      setLoading(false);
      ////document.getElementById('buscador')?.focus();
    }
  };
  

  const fetchDevelopers = async (projects) => {
    const devNames = {};
    for (const project of projects) {
      if (project.developers > 0) {
        try {
          const response = await ObexRequestHandler.get(`/organizations/${project.id}/developers`);
          devNames[project.id] = response.data?.[0]?.name || 'Unknown';
        } catch (error) {
          console.error(`Error fetching developer for project ${project.id}:`, error);
          devNames[project.id] = 'Unknown';
        }
      }
    }
    return devNames;
  };


  document.addEventListener('updateView', (e) => {
    if (SessionService.updating>0 && location.pathname == '/organizations') {
      SessionService.updating = SessionService.updating -3;
      getProjects('');
      fetchRegions();
      fetchDeployments();
      setSelectedOrg(SessionService.ORGANIZATION)
      window.scrollTo(0, 0);
      history.push('/organizations')
      console.log("XX")
    }
  }, false);
  

  const handleDelete = async (orgId) => {
    if (window.confirm('Are you sure you want to delete this organization?')) {
      try {
        await ObexRequestHandler.delete(`/organizations/${orgId}`); 
        
        getProjects(''); // Actualizar la lista después de eliminar
        history.push('/organizations')
      } catch (error) {
        console.error('Error deleting organization:', error);
        alert('Failed to delete the organization');
      }
    }
  };
  

  useEffect(() => {
    getProjects('');
    fetchRegions();
    fetchDeployments();
    setSelectedOrg(SessionService.ORGANIZATION)
    window.scrollTo(0, 0);

    function manejarUpdateView(event) {
      // Lógica para manejar el evento SessionService.updateView
      console.log('Evento SessionService.updateView capturado');
    }
    // Añadir listener al montar el componente
    document.addEventListener('updateView', manejarUpdateView);

    getConsumption();

    // Remover listener al desmontar el componente
    return () => {
      document.removeEventListener('updateView', manejarUpdateView);
    };
  }, []);

  return (
    <>
      <BrowserView>
        <DashLayout sider={DashRouters} active={'organizations'} sublinks={[]}>

          <Row id='topHeader'>
            <Col md="6" lg="10">
              <div className='d-flex flex-column'>
                <div className="cld_wrapperTitle">
                  <img style={{width:'24px'}} src={orgIcon} alt="icon dashboard" />
                  <span className="cld_title w-100 margin-y-24px">

                  <span className="cld_index">IAM </span>/ Organizations <p className="title_description">This is Organizations</p>
                  </span>
                </div>
 
                {/* <span className="cld_legend w-100">
                  View and manage a list of organizations you're associated with.
                </span> */}
              </div>
            </Col>




        <Col lg="2"  md="6"  className='align-content-center margin-y-24px'>
          {currentOrganizations < SusMax ? (
 
 
            (currentOrganizations < maxOrganizations ?
            <button
              style={{ width: '225px' }}
              className="btn-cmd-green-line float-right"
              onClick={() => setIsAddOrgDrawerOpen(true)} // Abre el modal para añadir una nueva organización
            >
              Create Organization
            </button>:
            <button
              style={{ width: '225px'}}
              className="btn-cmd-green-line float-right"
              onClick={() => setaddingOrg(true)} // Abre el modal para añadir una nueva organización
            >
              Add Organizations
            </button>)


          ) : (
            <button
            style={{ width: '225px'}}
              className="btn-cmd-green-line float-right"
              onClick={() => setShowUpgrade(true)} // Abre `AddOrganizationSlots` cuando se alcanza el límite
            >
              Upgrade Plan
            </button>
          )}
        </Col>


{/*}
            <Col md="2" className='align-content-center'>
              {currentOrganizations < maxOrganizations ? (
                <Button
                  style={{ width: '225px' }}
                  className="customButton-black btn px-4 float-right   resBtn"
                  onClick={() => {
                    fetchOrgDevs(selected_org, true);
                    setIsAddOrgDrawerOpen(true)
                    }
                  } // Abre el modal para añadir una nueva organización
                >
                  Create Organization
                </Button>
              ) : (
                <Button
                  style={{ width: '225px' }}
                  className="customButton-black btn px-4 float-right  resBtn"
                  onClick={() => setaddingOrg(true)} // Abre `AddOrganizationSlots` cuando se alcanza el límite
                >
                 Upgrade Plan
                </Button>
              )}
            </Col>

            */}
            <Col>
              <div className="customBorder"></div>
            </Col>
          </Row>

          {/* <Row id="searchContent" className='mt-5'>
            <div className="col">
              <Form.Row >
                <Col>
                  <Form.Control id='buscador' required type="text" value={filtro} placeholder="Search by Organization name"
                    onChange={changeFilter} />
                </Col>

                <Col md={3}>
                  <Button className=" customButton-blue w-100 px-4"
                    onClick={() => getProjects(filtro)}><FontAwesomeIcon icon={faSearch} size="1x" /></Button>
                </Col>
              </Form.Row>
            </div>
          </Row> */}

          <Row className="mt-5">
                  <Col md='4' className="searchContainer">
                    <Form.Control style={{
                      outline: 'none',
                      boxShadow: 'none',
                    }} id='buscador' required type="text" value={filtro} placeholder="Search by Organization name"
                      onChange={changeFilter} />
                   {/* <Button className="customButton-transparent px-4"
                      onClick={() => getProjects(filtro)}><FontAwesomeIcon icon={faSearch} size="1x" /></Button>*/}
                  </Col>
          </Row>

          <Row id='table' className='mt-4'>
            <Col>
              {addingOrg && (
                <AddOrganizationSlots shown={addingOrg} onCloseAction={closeOrg} onSuccess={handleOrg} MaxDBSize={1} ActualDBSize={0} cloud={true} />
              )}
              {loading ? (
                <Row style={{ textAlign: 'center', marginTop: '100px' }}>
                  <Col>
                 
                  </Col>
                </Row>
              ) : (
                <div className='cld_borderWrapper'>
                 {/* <span className='cld_sectionTitle'>Organizations</span>*/}

                  



                  {/* <Table className='cld_tableWrapper' responsive>
                    <tbody>
                      <tr>
                        <th className='textBold'>Name</th>
                        <th className='textBold'>Description</th>
                        <th className='textBold'># Of Developers</th>
                        <th className='textBold'>Action</th>
                      </tr>
                      {projects.map((project) => (
                        <tr className='tableRow' key={project.id}>
                          <td className='project'>{project.name}</td>
                          <td className='desc'>{project.description}</td>
                          <td className='devs'><div className="devsItem">{project.developers}</div></td>
                          <td className='text-right'>
                            <div className="actionsWrapper">
                              <a className="edit-link" onClick={() => handleModal2(project.id, project.name, project.description)}>
                                <span className="editIcon" style={{ backgroundImage: `url(${editicon})` }}></span>
                                Edit
                              </a>

                      
                              {project.developers === 0 && (
                                <button
                                  className="customButton-red ml-2"
                                  onClick={() => handleDelete(project.id)}
                                >
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
 */}


                  <Table className='cld_tableWrapper mt-0' responsive>
                    <tbody>
                      <tr className='tableRow'>
                        <th style={{ width:'20%' }} className='textBold'>Name</th>
                        <th style={{ width:'25%' }} className='textBold'>Location</th>
                        <th style={{ width:'30%' }} className='textBold'>Owner</th>
                        <th className='textBold'># Of Members</th>
                        <th style={{ width:'20px',
                        textAlign: 'center', 
                        verticalAlign: 'middle'  }} className='textBold'>Actions</th>
                      </tr>
                      {projects.length === 0 ? (
                        <tr>
                          <td colSpan={5}>
                              <div className='nodata-wrapper'>
                                <Nodata />
                              </div>
                          </td>
                        </tr>
                      ) : (projects.map((project) => (
                        <tr className='tableRow' key={project.id}>
                          <td className='td_centered project'>{project.name || 'Not specified'}</td>
                          <td className='td_centered location'>{project.region_name || 'Not specified'}</td>
                          <td className='td_centered responsible'>{project.responsible_email || 'Not specified'}</td>
                          <td className='td_centered devs'>
                            <div style={{ backgroundColor: 'var(--color-background-from)' }} className="devsItem">{project.developers || 0}</div>
                          </td>
                          <td className='text-centered'>
                            <div  className="actionsWrapper d-flex justify-content-center align-items-center h-100">
                              {/*<a className="edit-link" onClick={() => handleModal2(project.id, project.name, project.description)}>
                                <span className="editIcon" style={{ backgroundImage: `url(${editicon})` }}></span>
                                Edit
                              </a>*/}

                              <Dropdown className='my-auto ' style={{ marginRight:'2px' }}>
                                  <Dropdown.Toggle variant="" className="icon-edit-table">
                                    <FontAwesomeIcon className="icon-edit-table" icon={faEllipsisV}   />
                                  </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item key={1} onClick={ () => handleModal2(project.id, project.name, project.description, project.region_id, project.region_name, project.responsible_email, project.developer_id) }>Edit</Dropdown.Item>
                                      {(!project.developers || project.developers === 0) && <Dropdown.Item key={1} onClick={ () => handleDelete(project.id) }>Delete</Dropdown.Item>}
                                    </Dropdown.Menu>
                                </Dropdown>


                              {/* Mostrar el botón de eliminar solo si no hay miembros */}
                              {(!project.developers || project.developers === 0) && (
                                /*<a
                                
                                  className="edit-link ml-2"
                                  onClick={() => handleDelete(project.id)}
                                >
                                   <span className="editIcon" style={{ backgroundImage: `url(${deleteIcon})` }}></span>
                                  Delete
                                </a>*/
                                /*
                                <Dropdown className='my-auto' style={{marginRight:'20px'}}>
                                <Dropdown.Toggle className="organizations" >
                                  <FontAwesomeIcon icon={faEllipsisV}   />
                                </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item key={1} onClick={ () => setIsAddOrgDrawerOpen(true) }>Edit</Dropdown.Item>
                                    <Dropdown.Item key={1} onClick={ () => setIsAddOrgDrawerOpen(true) }>Delete</Dropdown.Item>
                                  </Dropdown.Menu>
                              </Dropdown>
                               </div>*/<></>

                              )}
                            </div>
                          </td>
                        </tr>
                      )))}
                    </tbody>
                  </Table>
                </div>
              )}
            </Col>
          </Row>

          {projects.length === 0 && !loading && (
            <div>
              <Row className="justify-content-center my-4">
                <Col xs="6" style={{ display: 'flex', justifyContent: 'center' }}>
                  <Image style={{ width: '50%', marginTop: '60px' }} src={Logo} fluid />
                </Col>
              </Row>
              <Col style={{ textAlign: 'center', marginBottom: '60px' }}>
                <Row><Col><h5>You don't have any data.</h5></Col></Row>
              {/*   <Row><Col>When you have data to show, you'll find here.</Col></Row> */}
              </Col>
            </div>
          )}

          {/* Drawer for Editing Organization */}
          <Drawer
            index='organizations'
            isOpen={isEditDrawerOpen}
            toggleSidebar={()=>toggleEditDrawer(selected_org)}
            name="Edit Organization"
          >
            <EditOrganizationModal
              isOpen={isEditDrawerOpen}
              organization={selected_org}
              organization_name={selected_org_name}
              organization_description={selected_org_description}
              organization_location_name={selected_org_region_name}
              organization_location={{ region_id: selected_org_region_id, region_name: selected_org_region_name }}
              organization_responsible={selected_org_responsible_email}
              handleClose={()=>editedDrawer(selected_org)}
              regions={regions}
              organization_devs={selected_org_devs}
              organization_responsible_id={selected_org_responsible_id}
              organization_location_id={selected_org_region_id}
            />
          </Drawer>


          <Drawer
            index='organizations'
            isOpen={isAddOrgDrawerOpen}
            toggleSidebar={()=>toggleAddOrgDrawer(selected_org)}
            name="Add Organization"
          >

            <AddOrganizationModal
              handleClose={() => toggleAddOrgDrawer(selected_org)} // Cierra el Drawer
              updateTable={() => getProjects('')} // Actualiza la tabla tras la creación
              show
              regions={regions}
              organization_devs={selected_org_devs}
              deployments={deployments}
              opened={isAddOrgDrawerOpen}
            />


                    <UpgradePlanModal 
                      showModal={ showUpgrade } 
                      text={'In order to create a developer portal you need to upgrade your plan. \n You have consumed the maximun slots available.'} 
                      onCloseModal={whenClosing} 
                      onCancelModal={whenClosing} 
                      currentSuscription={currentSuscripcion}
                      onSuccess={whenClosing}
                      />


          </Drawer>



        </DashLayout>
      </BrowserView>
      <MobileView>
        <Disclaimer />
      </MobileView>
    </>
  );
};

export default Organizations;
